/**
 * Console app configuration.
 *
 * The console drives a single live vault (Analytics + Vault Control). Both
 * values are CUE registry keys — the same handles the early-access flow uses —
 * resolved by `useVaultConfig` out of the deployment's OMTs.
 *
 * To point the console at a different vault, change `CONSOLE_VAULT_REF`.
 */

export const CONSOLE_DEPLOYMENT_ID = "thema/thema-dev/tbtc01";
// The ACTIVE vault. Its mast (via migrationSources) includes the migrated-from
// beta5, so depositor analytics aggregate the full history even though the live
// shares sit on beta6.
export const CONSOLE_VAULT_REF = "@beta6Vault";

// ThemaLPVault is itself the ERC-4626 share token. Its user-facing share label
// isn't surfaced through VaultConfig, so we hardcode the same symbol the vault
// surfaces elsewhere keep consistent.
export const SHARE_SYMBOL = "ThemaVaultShare";

// On-chain reads polling cadence (vault state + cap + user position). 15s ≈
// 7-8 blocks on Base — fast enough to reflect a fresh deposit, slow enough to
// not hammer public RPC endpoints.
export const POLL_INTERVAL_MS = 15_000;
